import {UITextMode} from './ui-text-mode.enum';
import {UITextWhitespace} from './ui-text-whitespace.enum';

export type UITextStylingProps = { mode: UITextMode | string, whitespace: UITextWhitespace | string };

export class UITextStyling {
    public props: UITextStylingProps;

    constructor(props: UITextStylingProps = {mode: UITextMode.default, whitespace: UITextWhitespace.normal}) {
        this.props = props;
    }

    public get ngClass() {
        return {
            '≈text-sm lg:≈text-base 2xl:≈text-lg ≈font-normal ≈font-apple-system ≈transition-all ≈duration-75': true,
            '≈text-default-text': this.modeIs(UITextMode.default),
            '≈text-subdued-text': this.modeIs(UITextMode.subdued),
            '≈text-disabled-text': this.modeIs(UITextMode.disabled),
            '≈text-critical-text': this.modeIs(UITextMode.critical),
            '≈text-warning-text': this.modeIs(UITextMode.warning),
            '≈text-success-text': this.modeIs(UITextMode.success),
            '≈text-highlight-text': this.modeIs(UITextMode.highlight),
            '≈text-primary-text': this.modeIs(UITextMode.primary),
            '≈text-white': this.modeIs(UITextMode.overInteractive)
                || this.modeIs(UITextMode.overPrimary)
                || this.modeIs(UITextMode.overCritical),
            '≈whitespace-normal': this.whitespaceIs(UITextWhitespace.normal),
            '≈whitespace-nowrap': this.whitespaceIs(UITextWhitespace.nowrap),
            '≈whitespace-pre': this.whitespaceIs(UITextWhitespace.pre),
            '≈whitespace-pre-line': this.whitespaceIs(UITextWhitespace.preLine),
            '≈whitespace-pre-wrap': this.whitespaceIs(UITextWhitespace.preWrap)
        };
    }


    public modeIs(mode: UITextMode | string): boolean {
        return mode == this.props.mode || mode == UITextMode[this.props.mode];
    }

    public whitespaceIs(whitespace: UITextWhitespace | string): boolean {
        return whitespace == this.props.whitespace || whitespace == UITextWhitespace[this.props.whitespace];
    }
}
